import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing16 } from 'approot/shared/styles/spacing.style';

export const RichtextLinkModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;

  button:last-of-type {
    margin-left: ${rem(spacing16)};
  }
`;

type RichtextAddLinkViewProps = {
  hide?: boolean;
};

export const RichtextLinkModalView = styled.div<RichtextAddLinkViewProps>`
  display: ${({ hide }) => (hide ? 'none' : 'block')};
`;
